// Sungem Calculator Plugin

var calc = {

	settings: {
    authenticated: false,
    currency: '$',
	  units: 'imperial',
    bundles: [
      {plankWidth: 2.25, squareFeet: 17.25},
      {plankWidth: 3.25, squareFeet: 12.25},
      {plankWidth: 4.25, squareFeet: 16.25},
      {plankWidth: 5.25, squareFeet: 20},
    ]
	},

  values: {},

  initialize: function initialize () {

    calc.handleFieldChanges();

		calc.handleSubmitButton();

    calc.computePrice();
  },

  computePrice: function computePrice () {

    var plankWidth = calc.getPlankWidth();

    var budleSquareFeet = Number(calc.getBundleSquareFeet(plankWidth));

    // Get total price per square foot
    var pricePerSquareFoot = Number(calc.getSquareFootPricingFromDOM(plankWidth)) + Number(calc.getPlankEdgeType());

    // Get total square feet with extra
    var finishedSquareFeet = Number(calc.getTotalSquareFeet());

		var extraFlooringRatio = Number(calc.getExtraFlooringPercentage());

    var totalSquareFeet = Math.round(finishedSquareFeet + (finishedSquareFeet * extraFlooringRatio));

    // Find out what the correct bundle size is
    var bundles = Math.ceil(totalSquareFeet / budleSquareFeet);

    var bundleSquareFeet = Math.round(bundles * budleSquareFeet * 100) / 100;

    // Multiply price by square footage
    var totalPrice = Math.round(bundleSquareFeet * pricePerSquareFoot * 100) / 100;

    calc.displayPrice(totalPrice);

		calc.displayUnitPrice(pricePerSquareFoot);

		calc.displayTotalBundles(bundles);

    calc.displaySquareFeet(bundleSquareFeet);

    return totalPrice;
  },

	handleSubmitButton: function handleSubmitButton () {

		$(".button-calculate").click(function(e) {

			e.preventDefault();

			$('html, body').animate({

			  scrollTop: $('.calculate hr').offset().top - 100
			}, 500);
		});
	},

  displayPrice: function displayPrice (price) {

    $('#total-price').val('$' + price);
  },

	displayUnitPrice: function displayUnitPrice (price) {

    $('.display-price').html('$' + price + '/sq. ft.');
  },

  displaySquareFeet: function displaySquareFeet (squareFeet) {

    $('#total-square-feet').val(squareFeet + ' sq. ft.');
  },

  getBundleSquareFeet: function getBundleSquareFeet (plankWidth) {

    var result = calc.settings.bundles.filter(function (item) { return item.plankWidth == Number(plankWidth) });

    return Number(result[0].squareFeet);
  },

  handleFieldChanges: function handleFieldChanges () {

    $(document).on('change', '.calculate #finished-square-feet, .calculate #board-edge, .calculate #board-width, .calculate #extra-flooring', function () {

      calc.computePrice();
    });

		$(document).on('click touch', '#bevel', function () {
			$('.calculate #board-edge option:eq(1)').attr('selected', 'selected').change();
		});

		$(document).on('click touch', '#square', function () {
			$('.calculate #board-edge option:eq(0)').attr('selected', 'selected').change();
		});

		$(document).on('click touch', '#rolled', function () {
			$('.calculate #board-edge option:eq(2)').attr('selected', 'selected').change();
		});

		// Change SVG color
		$(document).on('change', '.calculate #board-edge', function () {

			// Set them all to default
			$('#bevel, #square, #rolled').css({fill: '#999', opacity: 1.0});

			// Highlight the selected choice
			var selectedEdge = $('.calculate #board-edge option:selected').text();
			if (selectedEdge.indexOf('Square') !== -1) {
				$('#square').css({fill: '#c26d25'});
			}
			else if (selectedEdge.indexOf('Bevel') !== -1) {
				$('#bevel').css({fill: '#c26d25'});
			}
			else if (selectedEdge.indexOf('Rolled') !== -1) {
				$('#rolled').css({fill: '#c26d25'});
			}

    });
  },

  displayTotalBundles: function displayTotalBundles (bundles) {

    $('#total-bundles').val(bundles + ' Bundles');
  },

  getTotalSquareFeet: function getTotalSquareFeet () {

    return Number($('#finished-square-feet').val());
  },

  getPlankWidth: function getPlankWidth () {

    return Number($('#board-width').val());
  },

  getPlankEdgeType: function getPlankEdgeType () {

    return Number($('#board-edge').val());
  },

  getPlankFinish: function getPlankFinish () {

    return Number($('#pre-finish').val());
  },

  getExtraFlooringPercentage: function getExtraFlooringPercentage () {

    var extra = Number($('#extra-flooring').val());

    if (extra > 0) {
      extra = extra / 100;
    }

    return extra;
  },

  /*
  Return the price per square foot using product description text
  @plankWidth (string, int or float)  width of flooring planks e.g. 2.25
  @return     (float or boolean)   price per square foot or false if nothing is found
  */
  getSquareFootPricingFromDOM: function getSquareFootPricingFromDOM (plankWidth) {

    if ($('tr:contains(' + plankWidth + ') td:contains($)').length) {

      // Select the row with the width value and get the price column value
      var price = $('tr:contains(' + plankWidth + ') td:contains($)').text();

      // Strip out the non-numeric characters
      if ($.trim(price) !== '') {

        price = Number(price.replace(/[^0-9\.]+/g,''));
      }
      else {
        price = false;
      }

      return price;
    }
    else {
      return false;
    }
  }
}


// v 1.0.0
$( document ).ready(function() {

	// initialize
	calc.initialize();

});
